// Autogenerated by Hanako
import { Debug } from './components/Debug';
import { LazyLoader } from './components/LazyLoader';
import { Calendar } from '../../views/twig/components/Calendar';
import { Carousel } from '../../views/twig/components/Carousel';
import { Empty } from '../../views/twig/components/Empty';
import { Gallery } from '../../views/twig/components/Gallery';
import { Grid } from '../../views/twig/components/Grid';
import { Header } from '../../views/twig/components/Header';
import { Menu } from '../../views/twig/components/Menu';
import { RGPDConsent } from '../../views/twig/components/RGPDConsent';
import { SlideDown } from '../../views/twig/components/SlideDown';
import { Axo } from '../../views/twig/modules/axo';
import { Discover } from '../../views/twig/modules/discover';
import { Peoples } from '../../views/twig/modules/peoples';
import { ShowPreview } from '../../views/twig/modules/show-preview';
import { ArchiveEvents } from '../../views/twig/pages/archives/events';
import { GalleryPress } from '../../views/twig/pages/root/member-area-press';
import { Page } from '../../views/twig/pages/root/page';
import { Capsule } from '../../views/twig/pages/singles/capsule';
import { SingleShow } from '../../views/twig/pages/singles/show';
import { Title } from '../../views/twig/modules/title';
import { Ipad } from '../../views/twig/pages/root/ipad';
import { Story } from '../../views/twig/modules/story';
(new Debug()).init();
(new LazyLoader()).init();
(new Calendar()).init();
(new Carousel()).init();
(new Empty()).init();
(new Gallery()).init();
(new Grid()).init();
(new Header()).init();
(new Menu()).init();
(new RGPDConsent()).init();
(new SlideDown()).init();
(new Axo()).init();
(new Discover()).init();
(new Peoples()).init();
(new ShowPreview()).init();
(new ArchiveEvents()).init();
(new GalleryPress()).init();
(new Page()).init();
(new Capsule()).init();
(new SingleShow()).init();
(new Title()).init();
(new Ipad()).init();
(new Story()).init();
